import { InfoModalKey, ModalData } from '~app-client/info-modals/types';

export const keyToData: Record<InfoModalKey, ModalData> = {
	[InfoModalKey.LOCATION]: {
		i18nName: 'location',
		slides: [{ i18n: 'slide_1', imageName: 'location-slide-1.svg' }],
	},

	[InfoModalKey.CHANGE_WORKSPACE]: {
		i18nName: 'change_workspace',
		slides: [
			{ i18n: 'slide_1', imageName: 'change-workspace-slide-1.png' },
			{ i18n: 'slide_2', imageName: 'change-workspace-slide-2.png' },
			{ i18n: 'slide_3', imageName: 'change-workspace-slide-3.png' },
			{ i18n: 'slide_4', imageName: 'change-workspace-slide-4.png', videoId: 'uBHIgxZFp0A' },
		],
	},

	[InfoModalKey.NODE_INFO_INITIAL]: {
		i18nName: 'node_info.initial',
		slides: [
			{ i18n: 'slide_1', imageName: 'node-info-initial-slide-1.png' },
			{ i18n: 'slide_2', imageName: 'node-info-initial-slide-2.png' },
			{ i18n: 'slide_3', imageName: 'node-info-initial-slide-3.png' },
			{ i18n: 'slide_4', imageName: 'node-info-initial-slide-4.png' },
			{ i18n: 'slide_5', imageName: 'node-info-initial-slide-5.png' },
			{ i18n: 'slide_6', imageName: 'node-info-initial-slide-6.png' },
			{ i18n: 'slide_7', imageName: 'node-info-initial-slide-7.png' },
		],
	},
	[InfoModalKey.NODE_INFO_PROPERTIES]: {
		i18nName: 'node_info.add_properties',
		slides: [
			{ i18n: 'slide_1', imageName: 'node-info-properties-slide-1.png' },
			{ i18n: 'slide_2', imageName: 'node-info-properties-slide-2.png' },
			{ i18n: 'slide_3', imageName: 'node-info-properties-slide-3.png' },
			{
				i18n: 'slide_4',
				imageName: 'node-info-properties-slide-4.png',
				videoId: 'PdAjSHGnY8s',
			},
		],
	},
	[InfoModalKey.NODE_INFO_RELATIONSHIPS]: {
		i18nName: 'node_info.add_relationships',
		slides: [
			{ i18n: 'slide_1', imageName: 'node-info-relationships-slide-1.png' },
			{ i18n: 'slide_2', imageName: 'node-info-relationships-slide-2.png' },
			{ i18n: 'slide_3', imageName: 'node-info-relationships-slide-3.png' },
			{ i18n: 'slide_4', imageName: 'node-info-relationships-slide-4.png' },
			{ i18n: 'slide_5', imageName: 'node-info-relationships-slide-5.png' },
			{ i18n: 'slide_6', imageName: 'node-info-relationships-slide-6.png' },
			{
				i18n: 'slide_7',
				imageName: 'node-info-relationships-slide-7.png',
				videoId: '-mHKnd25Pf8',
			},
		],
	},
	[InfoModalKey.NODE_INFO_RECOMMENDATIONS]: {
		i18nName: 'node_info.recommendations',
		slides: [
			{ i18n: 'slide_1', imageName: 'node-info-recommendations-slide-1.png' },
			{ i18n: 'slide_2', imageName: 'node-info-recommendations-slide-2.png' },
			{ i18n: 'slide_3', imageName: 'node-info-recommendations-slide-3.png' },
			{ i18n: 'slide_4', imageName: 'node-info-recommendations-slide-4.png' },
			{ i18n: 'slide_5', imageName: 'node-info-recommendations-slide-5.png' },
		],
	},

	[InfoModalKey.SEARCH_NODES_FILTER]: {
		i18nName: 'search.nodes_filter',
		slides: [
			{ i18n: 'slide_1', imageName: 'search-nodes-filter-slide-1.png' },
			{ i18n: 'slide_2', imageName: 'search-nodes-filter-slide-2.png' },
			{ i18n: 'slide_3', imageName: 'search-nodes-filter-slide-3.png' },
		],
	},
	[InfoModalKey.SEARCH_NODES_OPERATOR]: {
		i18nName: 'search.relationships_operators',
		slides: [
			{ i18n: 'slide_1', imageName: 'search-relationships-operator-slide-1.png' },
			{ i18n: 'slide_2', imageName: 'search-relationships-operator-slide-2.png' },
			{ i18n: 'slide_3', imageName: 'search-relationships-operator-slide-3.png' },
		],
	},
	[InfoModalKey.SEARCH_NODES_TO_EXCLUDE_FILTER]: {
		i18nName: 'search.exclude_nodes_filter',
		slides: [
			{ i18n: 'slide_1', imageName: 'search-nodes-to-exclude-filter-slide-1.png' },
			{ i18n: 'slide_2', imageName: 'search-nodes-to-exclude-filter-slide-2.png' },
		],
	},
	[InfoModalKey.SEARCH_PROPERTIES_FILTER]: {
		i18nName: 'search.properties_filter',
		slides: [
			{ i18n: 'slide_1', imageName: 'search-properties-filter-slide-1.png' },
			{ i18n: 'slide_2', imageName: 'search-properties-filter-slide-2.png' },
			{ i18n: 'slide_3', imageName: 'search-properties-filter-slide-3.png' },
			{
				i18n: 'slide_4',
				imageName: 'search-properties-filter-slide-4.png',
				videoId: 'C2bhlFrNAHs',
			},
		],
	},
	[InfoModalKey.SEARCH_WORKSPACES_FILTER]: {
		i18nName: 'search.workspaces_filter',
		slides: [
			{ i18n: 'slide_1', imageName: 'search-workspaces-filter-slide-1.png' },
			{ i18n: 'slide_2', imageName: 'search-workspaces-filter-slide-2.png' },
		],
	},

	[InfoModalKey.SEARCH_VIEW_BIG_IMAGE]: {
		i18nName: 'search_view.big_image',
		slides: [
			{ i18n: 'slide_1', imageName: 'views-big-image-slide-1.png' },
			{ i18n: 'slide_2', imageName: 'views-big-image-slide-2.png' },
			{ i18n: 'slide_3', imageName: 'views-big-image-slide-3.png' },
		],
	},
	[InfoModalKey.SEARCH_VIEW_LIST]: {
		i18nName: 'search_view.list',
		slides: [
			{ i18n: 'slide_1', imageName: 'views-list-slide-1.png' },
			{ i18n: 'slide_2', imageName: 'views-list-slide-2.png' },
			{ i18n: 'slide_3', imageName: 'views-list-slide-3.png' },
		],
	},
	[InfoModalKey.SEARCH_VIEW_TABLE]: {
		i18nName: 'search_view.list',
		slides: [
			{ i18n: 'slide_1', imageName: 'views-list-slide-1.png' },
			{ i18n: 'slide_2', imageName: 'views-list-slide-2.png' },
			{ i18n: 'slide_3', imageName: 'views-list-slide-3.png' },
		],
	},
	[InfoModalKey.SEARCH_VIEW_BOARD]: {
		i18nName: 'search_view.board',
		slides: [
			{ i18n: 'slide_1', imageName: 'views-board-slide-1.png' },
			{ i18n: 'slide_2', imageName: 'views-board-slide-2.png' },
			{ i18n: 'slide_3', imageName: 'views-board-slide-3.png' },
		],
	},
	[InfoModalKey.SEARCH_VIEW_VISUALISER]: {
		i18nName: 'search_view.visualiser',
		slides: [
			{ i18n: 'slide_1', imageName: 'views-visualiser-slide-1.png' },
			// { i18n: 'slide_2', imageName: 'views-visualiser-slide-2.png' },
			{ i18n: 'slide_3', imageName: 'views-visualiser-slide-3.png' },
			{ i18n: 'slide_4', imageName: 'views-visualiser-slide-4.png' },
			{ i18n: 'slide_5', imageName: 'views-visualiser-slide-5.png' },
			{ i18n: 'slide_6', imageName: 'views-visualiser-slide-6.png' },
			// { i18n: 'slide_7', imageName: 'views-visualiser-slide-7.png' },
			{ i18n: 'slide_8', imageName: 'views-visualiser-slide-8.png' },
			{ i18n: 'slide_9', imageName: 'views-visualiser-slide-9.png', videoId: 'Qazd3mr90U0' },
		],
	},
	[InfoModalKey.TAG_TYPES_SMART_FEATURES]: {
		i18nName: 'tag_types.smart_features',
		slides: [
			{ i18n: 'slide_1', imageName: 'tag-types-smart-features-slide-1.png' },
			{ i18n: 'slide_2', imageName: 'tag-types-smart-features-slide-2.png' },
			{ i18n: 'slide_3', imageName: 'tag-types-smart-features-slide-3.png' },
			{ i18n: 'slide_4', imageName: 'tag-types-smart-features-slide-4.png' },
		],
	},
	[InfoModalKey.SF_WEBSITE_SETTINGS]: {
		i18nName: 'website_sf',
		slides: [
			{ i18n: 'slide_1', imageName: 'website-sf-slide-1.png' },
			{ i18n: 'slide_2', imageName: 'website-sf-slide-2.png' },
			{ i18n: 'slide_3', imageName: 'website-sf-slide-3.png' },
			{ i18n: 'slide_4', imageName: 'website-sf-slide-4.png' },
			{ i18n: 'slide_5', imageName: 'website-sf-slide-5.png' },
			{ i18n: 'slide_6', imageName: 'website-sf-slide-6.png' },
			{ i18n: 'slide_7', imageName: 'website-sf-slide-7.png' },
		],
	},
	[InfoModalKey.NODE_CREATION_WORKSPACE_SELECTOR]: {
		i18nName: 'node_creation.workspace_selector',
		slides: [{ i18n: 'slide_1', imageName: 'node-creation-workspace-selector-slide-1.png' }],
	},
	[InfoModalKey.NODE_CREATION_FILE]: {
		i18nName: 'node_creation.file',
		slides: [
			{ i18n: 'slide_1', imageName: 'node-creation-file-slide-1.png' },
			{ i18n: 'slide_2', imageName: 'node-creation-file-slide-2.png' },
			{ i18n: 'slide_3', imageName: 'node-creation-file-slide-3.png' },
			{ i18n: 'slide_4', imageName: 'node-creation-file-slide-4.png' },
		],
	},
	[InfoModalKey.NODE_CREATION_TAG]: {
		i18nName: 'node_creation.tag',
		slides: [
			{ i18n: 'slide_1', imageName: 'node-creation-tag-slide-1.png' },
			{ i18n: 'slide_2', imageName: 'node-creation-tag-slide-2.png' },
		],
	},
	[InfoModalKey.NODE_CREATION_NOTE]: {
		i18nName: 'node_creation.note',
		slides: [
			{ i18n: 'slide_1', imageName: 'node-creation-note-slide-1.png' },
			{ i18n: 'slide_2', imageName: 'node-creation-note-slide-2.png' },
			{ i18n: 'slide_3', imageName: 'node-creation-note-slide-3.png' },
		],
	},
	[InfoModalKey.NODE_CREATION_WEBSITE]: {
		i18nName: 'node_creation.website',
		slides: [
			{ i18n: 'slide_1', imageName: 'node-creation-website-slide-1.png' },
			{ i18n: 'slide_2', imageName: 'node-creation-website-slide-2.png' },
			{ i18n: 'slide_3', imageName: 'node-creation-website-slide-3.png' },
			{ i18n: 'slide_4', imageName: 'node-creation-website-slide-4.png' },
		],
	},
	[InfoModalKey.NODE_CREATION_WORKSPACE]: {
		i18nName: 'node_creation.workspace',
		slides: [{ i18n: 'slide_2', imageName: 'node-creation-workspace-slide-2.png' }],
	},

	// INTEGRATIONS
	[InfoModalKey.INTEGRATIONS_FIRST_TIME]: {
		i18nName: 'integrations.first_time',
		slides: [{ i18n: 'slide_1', imageName: 'integrations-first-time-slide-1.png' }],
	},

	[InfoModalKey.CHAT_AI_LEARN_ALL]: {
		i18nName: 'chat-ai.learn_all',
		slides: [
			{
				i18n: 'slide_1',
				imageName: 'chat-ai-learn-all-slide-1.png',
				closeOnOutsideClick: false,
				showCross: false,
			},
			{
				i18n: 'slide_2',
				imageName: 'chat-ai-learn-all-slide-2.png',
				closeOnOutsideClick: false,
				showCross: false,
			},
			{
				i18n: 'slide_3',
				imageName: 'chat-ai-learn-all-slide-3.png',
				closeOnOutsideClick: false,
				showCross: false,
			},
			{
				i18n: 'slide_4',
				imageName: 'chat-ai-learn-all-slide-4.png',
				closeOnOutsideClick: false,
				showCross: false,
			},
			{ i18n: 'slide_5', imageName: 'chat-ai-learn-all-slide-5.png' },
		],
	},
	[InfoModalKey.CHAT_AI_HOW_IT_WORKS]: {
		i18nName: 'chat-ai.how_it_works',
		slides: [
			{
				i18n: 'slide_1',
				imageName: 'chat-ai-how-it-works-slide-1.png',
			},
			{
				i18n: 'slide_2',
				imageName: 'chat-ai-how-it-works-slide-2.png',
			},
			{
				i18n: 'slide_3',
				imageName: 'chat-ai-how-it-works-slide-3.png',
			},
			{
				i18n: 'slide_4',
				imageName: 'chat-ai-how-it-works-slide-4.png',
			},
			{
				i18n: 'slide_5',
				imageName: 'chat-ai-how-it-works-slide-5.png',
			},
		],
	},
};
